import type { AllTableColumnsConfig, ClientConfig } from '@tmt-insights/oms_fe_core';
import { DeepPartial } from '@/redux/slices/slice_types';
import TitleHierarchy from '../components/TitleHierarchy';
import fileIngest from './columns/fileIngest';
import jobs from './columns/jobs';
import orders from './columns/orders';
import pendingAssets from './columns/pendingAssets';
import tasks from './columns/tasks';
import BBCFileIngestMediaInfo from './componentOverrides/BBCFileIngestMediaInfo/BBCFileIngestMediaInfo';
import dashboardConfig from './dashboardConfig';
import dataConfig from './dataConfig';
import { getUISchemaBBC } from './functionOverrides/schemaFormUtils';
import jobDetails from './jobDetails';
import orderPlacementConfig from './orderPlacementConfig';
import theme from './theme';
import titleConfig from './titleConfig';

const config: DeepPartial<ClientConfig> = {
  clientName: 'BBC',
  // colors/styling throughout the app
  theme,

  // any manipulation of the data as it is retrieved
  dataConfig,

  // customizations on dashboard page
  dashboardConfig,

  orderPlacementConfig,

  titleConfig,
  jobDetails,
  notifications: true,
  notificationsConfig: {
    version: 'v2'
  },
  // customization of table columns for each page
  columns: {
    orders,
    jobs,
    tasks,
    pendingAssets,
    fileIngest
  } as DeepPartial<AllTableColumnsConfig<unknown>>,

  // versionColors: {},

  userColors: [
    '#8E8DDC',
    '#92AD7B',
    '#0c61c8',
    '#219738',
    '#e5802e',
    '#dd3322',
    '#cc4466',
    '#5b0aaf',
    '#3a379d',
    '#008811',
    '#138592',
    '#996688',
    '#667799',
    '#4477bb',
    '#4466ff'
  ],
  versionColors: {
    edit: '#B16BE9',
    worldwide: '#5566ee'
  },
  enableUserDocumentation: true,

  // forces all job labels to use the same color, the one specified here
  // jobTypeLabelColor: 'blue',
  // taskTypeLabelColor: 'lavender'
  // disableJobDetailProxy: true

  bulkActionIcons: {
    cancel_job: 'cancel',
    restart_job: 'refresh',
    retry_rally_job: 'reset',
    asset_confirmation: 'check_double',
    clone_order: 'duplicate'
  },
  titleHierarchyComponent: TitleHierarchy,
  ingestManagementConfig: {
    version: 'v2',
    chart: {
      colors: ['primary', 'secondary', 'default'],
      glow: {
        opacity: 0.1,
        color: 'tertiary'
      }
    },
    readOnlyTitleAssociation: true
  },
  logoutConfig: {
    logoutEndpoint: '/auth/provider-logout/'
  },
  componentOverrides: {
    fileIngestMediaInfo: BBCFileIngestMediaInfo
  },
  functionOverrides: {
    getUISchema: getUISchemaBBC
  },
  localization: {
    namespace: 'bbc'
  },
  filtersVersion: 2
};

export default config;
